import React, { useState, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Divider, FormGroup, Grid, TextField, Typography } from "@material-ui/core";

import { exactLength, required, validEmail } from "../../../helpers/validations/validators";
import { ValidatorInputField } from "../../atomic/atoms/Inputs";
import { ValidatedDate } from "../../atomic/atoms/DatePicker";
import { GAccordion } from "../../atomic/organisms/GAccordion";
import { SelectValidatorGeneric } from "../../atomic/atoms/Select";
import { useTraslados } from "../../../hooks/useCases/useTraslados";
import { GCheckbox } from "../../atomic/atoms/GCheckbox";
import { ButtonGeneric, IconButtonGeneric } from "../../atomic/atoms/Buttons";
import { GenericModal } from "../../atomic/organisms/GenericModal";
import { GenericTable } from "../../atomic/organisms/GenericTable";
import BuscadorPractica from "../../turnos/coseguros/BuscadorPractica";
import moment from "moment";
import { startAlerta } from "../../../actions/ui/alertas";

const TYPES = {
    TEXT: 1,
    NUMBER: 2,
    DATE: 3,
    SELECT: 4,
    CHECKBOX: 5,
    BUTTON: 6,
    DIVIDER: 7,
    TITLE: 7,
    COMPONENT: 8
}

export const DatosTraslado = ({ formValues, setFormValues, modal, disabled }) => {
    const componentRef = useRef();
    const dispatch = useDispatch();
    const { data } = useTraslados();

    const { items: localidades } = useSelector((state) => state.localidades);
    const { items: provincias } = useSelector((state) => state.provincias);

    // const [modalEfectoresDesde, setModalEfectoresDesde] = useState(false);
    // const [modalEfectoresHasta, setModalEfectoresHasta] = useState(false);
    const [modalFecha, setModalFechas] = useState(false);
    // const [modalMedico, setModalMedico] = useState({
    //     open: false,
    //     domicilios: []
    // });

    const [practicaPrestacion, setPracticaPrestacion] = useState(formValues?.traslado?.prestacionTraslado?.practica || null);

    const handleChange = (type, value) => {
        if (type === "traslado") {
            setFormValues({
                traslado: {
                    ...formValues.traslado,
                    ...value
                }
            });
        }

        if (type === "accesorios")
            setFormValues({
                traslado: {
                    ...formValues.traslado,
                    accesorios: value
                }
            });

        if (type === "fechas") {
            const newValues = {
                ...formValues.traslado,
                fechas: value
            }
            setFormValues({
                traslado: newValues
            });
        }

        if (type === "direccionTraslado") {
            setFormValues({
                traslado: {
                    ...formValues.traslado,
                    direccionTraslado: {
                        ...formValues.traslado.direccionTraslado,
                        ...value
                    }
                }
            });
        }

        if (type === "prestacionTraslado")
            setFormValues({
                traslado: {
                    ...formValues.traslado,
                    prestacionTraslado: {
                        ...formValues.traslado.prestacionTraslado,
                        ...value
                    }
                }
            });

        if (type === "medico")
            setFormValues({
                medico: {
                    ...formValues.medico,
                    ...value
                }
            });
    };

    const showAccesorios =
        formValues.traslado?.idTipoTraslado &&
        data.dim.tiposTraslados.find(({ id }) => id === formValues.traslado?.idTipoTraslado)?.descripcion !== "Remis";

    const filtroTipoPrestacion = data.dim.tipoPrestaciones.find(x => x.id === formValues.traslado?.prestacionTraslado.idTipo)?.filtro;
    const practicaTerapeutica = data.dim.tipoPrestaciones.find(x => x.id === formValues.traslado?.prestacionTraslado.idTipo)?.descripcion === "Practica Terapeutica";

    const TrasladoFormList = [
        // TRANSPORTE
        {
            startOpen: true,
            title: "Transporte",
            form: [
                {
                    size: 8,
                    type: TYPES.SELECT,
                    list: data.dim.tiposTraslados.map(({ id, descripcion }) => ({ label: descripcion, value: id })),
                    label: "Tipo Traslado",
                    value: formValues.traslado?.idTipoTraslado,
                    onChange: (e) => handleChange("traslado", { idTipoTraslado: e.target.value, accesorios: showAccesorios ? formValues.traslado.accesorios : [] }),
                    validations: [required],
                    disabled
                },
                {
                    size: 4,
                    type: TYPES.CHECKBOX,
                    list: [
                        {
                            label: "Con Espera",
                            value: formValues.traslado?.conEspera,
                            checked: formValues.traslado?.conEspera,
                            onChange: (e) => handleChange("traslado", { conEspera: e.target.checked }),
                            disabledCheck: disabled
                        },
                        {
                            label: "Con Retorno",
                            value: formValues.traslado?.conRegreso,
                            checked: formValues.traslado?.conRegreso,
                            onChange: (e) => handleChange("traslado", { conRegreso: e.target.checked }),
                            disabledCheck: disabled
                        }
                    ],
                },
                showAccesorios ? {
                    type: TYPES.CHECKBOX,
                    list: data.dim.accesorios.map(({ id, descripcion }) => ({
                        label: descripcion,
                        value: id,
                        checked: formValues.traslado.accesorios.some(x => x.id === id),
                        disabledCheck: disabled,
                        onChange: (_, val) => {
                            handleChange("traslado", {
                                accesorios: formValues.traslado.accesorios.some(v => v.id === val) ? (
                                    formValues.traslado.accesorios.filter(v => v.id !== val)
                                ) : (
                                    [...formValues.traslado.accesorios, data.dim.accesorios.find((accesorio) => accesorio.id === val)]
                                )
                            })
                        }
                    }
                    )),
                } : {},
                formValues.traslado.accesorios.some(x => x.id === data.dim.accesorios.find(x => x.descripcion === "Bomba de Infusion")?.id) ? {
                    size: 2,
                    label: "Cantidad de Bombas",
                    type: TYPES.NUMBER,
                    value: formValues.traslado?.accesorios?.find((accesorio) => accesorio.descripcion === "Bomba de Infusion")?.cantidad ?
                        formValues.traslado?.accesorios?.find((accesorio) => accesorio.descripcion === "Bomba de Infusion")?.cantidad : "",
                    onChange: ({ target }) => handleChange("traslado", {
                        accesorios: [
                            ...formValues.traslado.accesorios.filter(x => x.id !== data.dim.accesorios.find(x => x.descripcion === "Bomba de Infusion")?.id),
                            {
                                ...data.dim.accesorios.find(accesorio => accesorio.descripcion === "Bomba de Infusion"),
                                cantidad: target.value
                            }
                        ]
                    }),
                    disabled
                } : {},
                {
                    size: formValues.traslado.accesorios.some(x => x.id === data.dim.accesorios.find(x => x.descripcion === "Bomba de Infusion")?.id) ? 10 : 12,
                    label: "Observaciones",
                    type: TYPES.TEXT,
                    value: formValues.traslado?.observaciones,
                    onChange: ({ target }) => handleChange("traslado", { observaciones: target.value }),
                }
            ]
        },

        // TRASLADOS DESDE - HASTA
        {
            title: "Traslados Desde - Hasta",
            form: [
                { type: TYPES.TITLE, subTitle: "Dirección Desde" },
                // {
                //     size: 6,
                //     type: TYPES.BUTTON,
                //     buttonLabel: "Institución",
                //     onClick: () => setModalEfectoresDesde(true),
                //     closeModal: () => setModalEfectoresDesde(false),
                //     modalTitle: "Seleccionar Institución",
                //     open: modalEfectoresDesde,
                //     // buttonDisabled: disabled || formValues.efector.efectorContactos.length === 0,
                //     buttonDisabled: true,
                //     modal: (
                //         <ModalEfectores
                //             listEfectores={formValues.efector?.efectorContactos ? formValues.efector?.efectorContactos : []}
                //             listMedicos={[]}
                //             handleChange={(_, value) => {
                //                 handleChange("direccionTraslado", {
                //                     idInstitucionDesde: value.idEfectorFacturacion,
                //                     descripcionInstitucionDesde: formValues.efector.razonSocial,
                //                     direccionDesde: `${value.calle} ${value.nro}`,
                //                     localidadDesde: localidades.find(({id_localidad}) => id_localidad === value.idLocalidad).descripcion_localidad ?
                //                     localidades.find(({id_localidad}) => id_localidad === value.idLocalidad).descripcion_localidad : "",
                //                     provinciaDesde: provincias.find(({id_provincia}) => id_provincia === value.idProvincia).descripcion_provincia ? 
                //                     provincias.find(({id_provincia}) => id_provincia === value.idProvincia).descripcion_provincia : "",
                //                     telefonoDesde: value.telefono,
                //                 });
                //                 setModalEfectoresDesde(false);
                //             }}
                //         />
                //     )
                // },
                {
                    size: 6,
                    type: TYPES.BUTTON,
                    buttonLabel: "Afiliado",
                    buttonDisabled: disabled,
                    onClick: () => {
                        handleChange("direccionTraslado", {
                            idInstitucionDesde: 0,
                            descripcionInstitucionDesde: formValues.afiliado.apellido_y_nombre ? formValues.afiliado.apellido_y_nombre : "",
                            direccionDesde: formValues.afiliado.domiciliosAfiliados.calle ? `${formValues.afiliado.domiciliosAfiliados.calle} ${formValues.afiliado.domiciliosAfiliados.nro}` : "",
                            localidadDesde: localidades.find(({ id_localidad }) => id_localidad === formValues.afiliado.domiciliosAfiliados.id_localidad)?.descripcion_localidad ?
                                localidades.find(({ id_localidad }) => id_localidad === formValues.afiliado.domiciliosAfiliados.id_localidad)?.descripcion_localidad : "",
                            provinciaDesde: provincias.find(({ id_provincia }) => id_provincia === formValues.afiliado.domiciliosAfiliados.id_provincia)?.descripcion_provincia ?
                                provincias.find(({ id_provincia }) => id_provincia === formValues.afiliado.domiciliosAfiliados.id_provincia)?.descripcion_provincia : "",
                            telefonoDesde: formValues.afiliado.domiciliosAfiliados ? formValues.afiliado.domiciliosAfiliados.telefono : "",
                        });
                    },
                },
                {
                    label: "Institución - Afiliado",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.descripcionInstitucionDesde,
                    onChange: ({ target }) => handleChange("direccionTraslado", { descripcionInstitucionDesde: target.value }),
                    validations: [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Dirección",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.direccionDesde,
                    onChange: ({ target }) => handleChange("direccionTraslado", { direccionDesde: target.value }),
                    validations: [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Entre Calles",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.entreCallesDesde,
                    onChange: ({ target }) => handleChange("direccionTraslado", { entreCallesDesde: target.value }),
                    disabled
                },
                {
                    size: 6,
                    label: "Localidad",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.localidadDesde,
                    onChange: ({ target }) => handleChange("direccionTraslado", { localidadDesde: target.value }),
                    validations: [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Municipio",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.municipioDesde,
                    onChange: ({ target }) => handleChange("direccionTraslado", { municipioDesde: target.value }),
                    disabled
                },
                {
                    size: 6,
                    label: "Provincia",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.provinciaDesde,
                    onChange: ({ target }) => handleChange("direccionTraslado", { provinciaDesde: target.value }),
                    validations: [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Teléfono",
                    type: TYPES.NUMBER,
                    value: formValues.traslado.direccionTraslado?.telefonoDesde,
                    onChange: ({ target }) => { if (target.value.length <= 10) handleChange("direccionTraslado", { telefonoDesde: target.value }) },
                    validations: [required, exactLength(10)],
                    disabled
                },
                { type: TYPES.DIVIDER },
                { type: TYPES.TITLE, subTitle: "Dirección Hasta" },
                // {
                //     size: 6,
                //     type: TYPES.BUTTON,
                //     buttonLabel: "Institución",
                //     onClick: () => setModalEfectoresHasta(true),
                //     closeModal: () => setModalEfectoresHasta(false),
                //     modalTitle: "Seleccionar Institución",
                //     open: modalEfectoresHasta,
                //     buttonDisabled: disabled || formValues.efector.efectorContactos.length === 0,
                //     modal: (
                //         <ModalEfectores
                //             listEfectores={formValues.efector.efectorContactos ? formValues.efector.efectorContactos : []}
                //             listMedicos={[]}
                //             handleChange={(type, value) => {
                //                 handleChange("direccionTraslado", {
                //                     idInstitucionHasta: value.idEfectorFacturacion,
                //                     descripcionInstitucionHasta: type === "efector" ? formValues.efector.razonSocial : formValues.prestador.nombreApellido,
                //                     direccionHasta: type === "efector" ? `${value.calle} ${value.nro}` : value.domicilio,
                //                     localidadHasta: localidades.find(({id_localidad}) => id_localidad === value.idLocalidad).descripcion_localidad ?
                //                     localidades.find(({id_localidad}) => id_localidad === value.idLocalidad).descripcion_localidad : "",
                //                     provinciaHasta: provincias.find(({id_provincia}) => id_provincia === value.idProvincia).descripcion_provincia ? 
                //                     provincias.find(({id_provincia}) => id_provincia === value.idProvincia).descripcion_provincia : "",
                //                     telefonoHasta: value.telefono,
                //                 });
                //                 setModalEfectoresHasta(false);
                //             }}
                //         />
                //     )
                // },
                {
                    size: 6,
                    type: TYPES.BUTTON,
                    buttonLabel: "Afiliado",
                    buttonDisabled: disabled,
                    onClick: () => {
                        handleChange("direccionTraslado", {
                            idInstitucionDesde: 0,
                            descripcionInstitucionHasta: formValues.afiliado.apellido_y_nombre ? formValues.afiliado.apellido_y_nombre : "",
                            direccionHasta: formValues.afiliado.domiciliosAfiliados.calle ? `${formValues.afiliado.domiciliosAfiliados.calle} ${formValues.afiliado.domiciliosAfiliados.nro}` : "",
                            localidadHasta: localidades.find(({ id_localidad }) => id_localidad === formValues.afiliado.domiciliosAfiliados.id_localidad)?.descripcion_localidad ?
                                localidades.find(({ id_localidad }) => id_localidad === formValues.afiliado.domiciliosAfiliados.id_localidad)?.descripcion_localidad : "prueba",
                            provinciaHasta: provincias.find(({ id_provincia }) => id_provincia === formValues.afiliado.domiciliosAfiliados.id_provincia)?.descripcion_provincia ?
                                provincias.find(({ id_provincia }) => id_provincia === formValues.afiliado.domiciliosAfiliados.id_provincia)?.descripcion_provincia : "",
                            telefonoHasta: formValues.afiliado.domiciliosAfiliados ? formValues.afiliado.domiciliosAfiliados.telefono : "",
                        });
                    },
                },
                {
                    label: "Institución - Afiliado",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.descripcionInstitucionHasta,
                    onChange: ({ target }) => handleChange("direccionTraslado", { descripcionInstitucionHasta: target.value }),
                    validations: [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Dirección",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.direccionHasta,
                    onChange: ({ target }) => handleChange("direccionTraslado", { direccionHasta: target.value }),
                    validations: [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Entre Calles",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.entreCallesHasta,
                    onChange: ({ target }) => handleChange("direccionTraslado", { entreCallesHasta: target.value }),
                    disabled
                },
                {
                    size: 6,
                    label: "Localidad",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.localidadHasta,
                    onChange: ({ target }) => handleChange("direccionTraslado", { localidadHasta: target.value }),
                    validations: [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Municipio",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.municipioHasta,
                    onChange: ({ target }) => handleChange("direccionTraslado", { municipioHasta: target.value }),
                    disabled
                },
                {
                    size: 6,
                    label: "Provincia",
                    type: TYPES.TEXT,
                    value: formValues.traslado.direccionTraslado?.provinciaHasta,
                    onChange: ({ target }) => handleChange("direccionTraslado", { provinciaHasta: target.value }),
                    validations: [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Teléfono",
                    type: TYPES.NUMBER,
                    value: formValues.traslado.direccionTraslado?.telefonoHasta,
                    onChange: ({ target }) => { if (target.value.length <= 10) handleChange("direccionTraslado", { telefonoHasta: target.value }) },
                    validations: [required, exactLength(10)],
                    disabled
                },
            ]
        },

        // MOTIVO TRASLADO
        {
            title: "Motivo Traslado",
            form: [
                {
                    type: TYPES.SELECT,
                    list: data.dim.motivosTraslados.map(({ id, descripcion }) => ({ label: descripcion, value: id })),
                    label: "Motivo Traslado",
                    value: formValues.traslado?.idMotivoTraslado,
                    onChange: (e) => handleChange("traslado", {
                        idMotivoTraslado: e.target.value,
                        motivoNodiambula: data.dim.motivosTraslados.find(({ id }) => id === e.target.value)?.descripcion === "Marcha Independiente"
                            ? "" : formValues.traslado.motivoNodiambula
                    }),
                    validations: [required],
                    disabled
                },
                {
                    label: "Motivo no Diambula",
                    type: TYPES.TEXT,
                    // validations: data.dim.motivosTraslados.find(({id}) => id === formValues.traslado?.idMotivoTraslado)?.descripcion !== "Marcha Independiente" ? [required] : [],
                    disabled: data.dim.motivosTraslados.find(({ id }) => id === formValues.traslado?.idMotivoTraslado)?.descripcion === "Marcha Independiente" || disabled,
                    multiline: true,
                    value: formValues.traslado.motivoNodiambula,
                    onChange: ({ target }) => handleChange("traslado", { motivoNodiambula: target.value }),
                },
            ]
        },

        // PRESTACION A REALIZAR
        {
            title: "Prestacion a Realizar",
            form: [
                {
                    size: 8,
                    type: TYPES.SELECT,
                    list: data.dim.tipoPrestaciones.map(({ id, descripcion }) => ({ label: descripcion, value: id })),
                    label: "Tipo Prestacion",
                    value: formValues.traslado?.prestacionTraslado.idTipo,
                    onChange: (e) => {
                        setPracticaPrestacion(null);
                        handleChange("prestacionTraslado", {
                            idTipo: e.target.value,
                            institucion: "",
                            cama: "",
                            idSector: "",
                            practicaDiagnostico: "",
                            practicaTerapeutica: "",
                        });
                    },
                    validations: [required],
                    disabled
                },
                {
                    size: 4,
                    type: TYPES.SELECT,
                    list: data.dim.codigos.map(({ id, descripcion }) => ({ label: descripcion, value: id })),
                    label: "Código Traslado",
                    value: formValues.traslado?.idCodigoTraslado,
                    onChange: (e) => handleChange("traslado", { idCodigoTraslado: e.target.value }),
                    disabled
                },

                (filtroTipoPrestacion === "Institucion" ? {
                    type: TYPES.COMPONENT,
                    component: (
                        <Grid container spacing={2}>
                            {[
                                {
                                    size: 8,
                                    component: (
                                        <ValidatorInputField
                                            variant="standard"
                                            label="Institución"
                                            value={formValues.traslado.prestacionTraslado?.institucion}
                                            margin="normal"
                                            onChange={(e) => handleChange("prestacionTraslado", { institucion: e.target.value })}
                                            validations={[required]}
                                            disabled={disabled}
                                        />
                                    )
                                },
                                {
                                    size: 4,
                                    component: (
                                        <ValidatorInputField
                                            variant="standard"
                                            label="Cama"
                                            value={formValues.traslado.prestacionTraslado?.cama}
                                            margin="normal"
                                            onChange={(e) => handleChange("prestacionTraslado", { cama: e.target.value })}
                                            validations={[required]}
                                            disabled={disabled}
                                        />
                                    )
                                },
                                {
                                    component: (
                                        <SelectValidatorGeneric
                                            label="Sectores"
                                            value={formValues.traslado.prestacionTraslado?.idSector}
                                            onChange={(e) => handleChange("prestacionTraslado", { idSector: e.target.value })}
                                            menuItems={data.dim.sectoresTraslados.map(({ id, descripcion }) => ({ value: id, label: descripcion }))}
                                            disabled={disabled}
                                        />
                                    )
                                },
                            ].map(({ size = 12, component }, index) => (
                                <Grid item xs={12} md={size} key={index}>
                                    {component}
                                </Grid>
                            ))}
                        </Grid>
                    )
                } : {}),

                (filtroTipoPrestacion === "Practica" ? {
                    type: TYPES.COMPONENT,
                    component: (
                        <BuscadorPractica
                            ref={componentRef}
                            cod={practicaPrestacion}
                            label="Código Practica"
                            fieldsDisabled={false}
                            autorizacion={true}
                            setCod={(val) => {
                                setPracticaPrestacion(val);
                                handleChange("prestacionTraslado", practicaTerapeutica ? {
                                    practicaTerapeutica: val?.codNom || ""
                                } : {
                                    practicaDiagnostico: val?.codNom || ""
                                });
                            }}
                        />
                    )
                } : {}),
            ]
        },

        // FECHA Y HORA
        {
            title: "Fecha y Hora del Traslado",
            form: [
                {
                    type: TYPES.COMPONENT,
                    component: (
                        <Grid container spacing={1}>
                            {!disabled && (
                                <Grid item xs={12} style={{ textAlign: "end" }}>
                                    <ButtonGeneric
                                        type="button"
                                        text="Agregar Fecha"
                                        size="small"
                                        onClick={() => setModalFechas(true)}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <GenericTable
                                    ref={componentRef}
                                    data={formValues.traslado.fechas || []}
                                    align="center"
                                    columns={[
                                        {
                                            label: "Fecha",
                                            customBody: (item) => moment(item?.fecha).format("DD/MM/YYYY")
                                        },
                                        {
                                            label: "Hora",
                                            id: "hora"
                                        },
                                        {
                                            label: "",
                                            customBody: ({ fecha, hora }) => (
                                                <IconButtonGeneric
                                                    onClick={() => {
                                                        
                                                        handleChange("fechas", formValues.traslado.fechas.filter(({ fecha: f, hora: h }) => f !== fecha || hora !== h));
                                                        if (!modal) dispatch(
                                                            startAlerta(
                                                                `Fecha Eliminada Correctamente`,
                                                                'success',
                                                                'Comando Exitoso',
                                                            ),
                                                        );
                                                    }}
                                                    disabled={disabled}
                                                />
                                            )
                                        }
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    )
                }
            ]
        },

        // MEDICO TRATANTE
        {
            title: "Datos del Médico Tratante",
            // disabledAccordion: !formValues.idMedico,
            form: [
                // {
                //     type: TYPES.BUTTON,
                //     buttonLabel: "Domicilios Médico",
                //     onClick: () => get.contratos.domiciliosMedico(formValues?.idMedico, (domicilios) => setModalMedico({open: true, domicilios})),
                //     closeModal: () => setModalMedico({open: false, domicilios: []}),
                //     modalTitle: "Seleccionar Domicilio Médico",
                //     buttonDisabled: !formValues.idMedico || disabled,
                //     open: modalMedico.open,
                //     modal: (
                //         <ModalEfectores 
                //             listMedicos={modalMedico.domicilios}
                //             listEfectores={[]}
                //             handleChange={(_, value) => {
                //                 handleChange("medico", {
                //                     localidad: value.localidad,
                //                     provincia: value.provincia,
                //                     telefono: value.telefono,
                //                 });
                //                 setModalMedico({open: false, domicilios: []});
                //             }}
                //         />
                //     )
                // },
                {
                    label: "Nombre / Apellido",
                    type: TYPES.TEXT,
                    value: formValues.medico?.apellidoNombre,
                    onChange: ({ target }) => handleChange("medico", { apellidoNombre: target.value }),
                    //validations: !formValues.idMedico ? [] : [required],
                    disabled
                },
                {
                    size: 6,
                    label: "Matricula Nacional",
                    type: TYPES.TEXT,
                    value: formValues.medico?.matriculaNac,
                    onChange: ({ target }) => { if (target.value.length <= 6) handleChange("medico", { matriculaNac: target.value }) },
                    //validations: !formValues.idMedico ? [] : [required, exactLength(6)],
                    disabled
                },
                {
                    size: 6,
                    label: "Matricula Provincial",
                    type: TYPES.TEXT,
                    value: formValues.medico?.matriculaProv,
                    onChange: ({ target }) => { if (target.value.length <= 5) handleChange("medico", { matriculaProv: target.value }) },
                    //validations: !formValues.idMedico ? [] : [required, exactLength(5)],
                    disabled
                },
                {
                    size: 6,
                    label: "Localidad",
                    type: TYPES.TEXT,
                    value: formValues.medico?.localidad,
                    onChange: ({ target }) => handleChange("medico", { localidad: target.value }),
                    disabled
                },
                {
                    size: 6,
                    label: "Provincia",
                    type: TYPES.TEXT,
                    value: formValues.medico?.provincia,
                    onChange: ({ target }) => handleChange("medico", { provincia: target.value }),
                    disabled
                },
                {
                    size: 6,
                    label: "Email",
                    type: TYPES.TEXT,
                    value: formValues.medico?.email,
                    onChange: ({ target }) => handleChange("medico", { email: target.value }),
                    validations: !formValues.idMedico ? [] : [validEmail],
                    disabled
                },
                {
                    size: 6,
                    label: "Teléfono",
                    type: TYPES.NUMBER,
                    value: formValues.medico?.telefono,
                    onChange: ({ target }) => { if (target.value.length <= 10) handleChange("medico", { telefono: target.value }) },
                    //validations: !formValues.idMedico ? [] : [required, exactLength(10)],
                    disabled
                }
            ]
        },
    ];

    return (
        <Grid container spacing={2} style={{ padding: "1em" }}>
            {TrasladoFormList.map(({ title, form, disabledAccordion, startOpen = false }, index) => (
                <Grid item xs={12} key={index}>
                    <GAccordion
                        title={<Typography variant="h6">{title}</Typography>}
                        startOpen={startOpen}
                        disabled={disabledAccordion}
                    >
                        <Grid container spacing={1}>
                            {form.map(({ size = 12, type, onChange = () => { }, label, value, name, list = [], validations, disabled = false, modal, component, ...props }, index) => (
                                <Grid item xs={12} md={size} key={index}>
                                    {(type === TYPES.TEXT || type === TYPES.NUMBER) && (
                                        <ValidatorInputField
                                            variant="standard"
                                            label={label}
                                            value={value}
                                            margin="normal"
                                            onChange={onChange}
                                            validations={validations}
                                            type={type === TYPES.NUMBER ? "number" : "text"}
                                            disabled={disabled}
                                            {...props}
                                        />
                                    )}

                                    {type === TYPES.DATE && (
                                        <ValidatedDate
                                            style={{ padding: "0 0.5em" }}
                                            value={value}
                                            label={label}
                                            onChange={onChange}
                                            fullWidth
                                            margin="normal"
                                            validations={validations}
                                            disabled={disabled}
                                            {...props}
                                        />
                                    )}

                                    {type === TYPES.SELECT && (
                                        <SelectValidatorGeneric
                                            label={label}
                                            name={name}
                                            value={value}
                                            onChange={onChange}
                                            menuItems={list}
                                            validations={validations}
                                            disabled={disabled}
                                            {...props}
                                        />
                                    )}

                                    {type === TYPES.CHECKBOX && (
                                        <FormGroup aria-label="position" row style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                            {list.map(({ value, label, onChange, checked, disabledCheck }, i) => (
                                                <GCheckbox
                                                    key={i}
                                                    label={label}
                                                    value={value}
                                                    checked={checked}
                                                    onChange={onChange}
                                                    disabled={disabledCheck}
                                                    {...props}
                                                />
                                            ))}
                                        </FormGroup>
                                    )}

                                    {type === TYPES.BUTTON && (
                                        <ButtonGeneric
                                            type="button"
                                            size="small"
                                            text={props.buttonLabel}
                                            disabled={props.buttonDisabled}
                                            onClick={props.onClick}
                                        />
                                    )}

                                    {type === TYPES.DIVIDER && (
                                        <Divider />
                                    )}

                                    {type === TYPES.TITLE && (
                                        <Typography style={{ width: "100%", marginBottom: "0.5em" }} variant="h6">{props.subTitle}</Typography>
                                    )}

                                    {type === TYPES.COMPONENT && (
                                        <Fragment>
                                            {component}
                                        </Fragment>
                                    )}

                                    {props.open && (
                                        <GenericModal
                                            open={props.open}
                                            title={props.modalTitle}
                                            gridStyle={{ textAlign: 'center', padding: '1em' }}
                                            {...(props.handleClose ? { handleClose: props.handleClose } : {})}
                                            {...props}
                                        >
                                            {modal}
                                        </GenericModal>
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    </GAccordion>
                </Grid>
            ))}

            {modalFecha && (
                <GenericModal
                    open={modalFecha}
                    title="Agregar Fecha"
                    gridStyle={{ textAlign: 'center', padding: '1em' }}
                    closeModal={() => setModalFechas(false)}
                    withoutPadding
                    withoutButtons
                >
                    <ModalFecha
                        handleSave={(values) => {
                            handleChange("fechas", [...formValues.traslado.fechas, values]);
                            setModalFechas(false);
                            if (!modal) dispatch(
                                startAlerta(
                                    `Fecha Guardada Correctamente`,
                                    'success',
                                    'Comando Exitoso',
                                ),
                            );
                        }}
                    />
                </GenericModal>
            )}
        </Grid>
    );
};

// const ModalEfectores = ({ listEfectores  = [], listMedicos = [], handleChange }) => {
//     const componentRef = useRef();

//     const { items: localidades } = useSelector((state) => state.localidades);
//     const { items: provincias } = useSelector((state) => state.provincias);

//     return (
//         <Fragment>
//             {[
//                 (listEfectores.length > 0 ? {
//                     title: "Domicilios Efector",
//                     data: listEfectores,
//                     columns: [
//                         {
//                             label: "",
//                             customBody: (efectorContacto) => (
//                                 <GCheckbox 
//                                     value={false}
//                                     onChange={() => handleChange("efector", efectorContacto)}
//                                 />
//                             )
//                         },
//                         {
//                             label: "Domicilio",
//                             customBody: (efectorContacto) => (efectorContacto.calle && efectorContacto.nro) ? `${efectorContacto.calle+ efectorContacto.nro}` : "No informado"
//                         },
//                         {
//                             label: "Domicilio",
//                             customBody: (efectorContacto) => efectorContacto.cp ? efectorContacto.cp : "No informado"
//                         },
//                         {
//                             label: "Localidad",
//                             customBody: (efectorContacto) => efectorContacto.idLocalidad ? localidades.find(({id_localidad}) => id_localidad === efectorContacto.idLocalidad).descripcion_localidad : "No informado"
//                         },
//                         {
//                             label: "Provincia",
//                             customBody: (efectorContacto) => efectorContacto.idProvincia ? provincias.find(({id_provincia}) => id_provincia === efectorContacto.idProvincia).descripcion_provincia : "No informado"
//                         },
//                         {
//                             label: "Teléfono",
//                             customBody: (efectorContacto) => efectorContacto.telefono ? efectorContacto.telefono : "No informado"
//                         },
//                     ]
//                 } : {}),

//                 (listMedicos.length > 0 ? {
//                     title: "Domicilios Prescriptor",
//                     data: listMedicos,
//                     columns: [
//                         {
//                             label: "",
//                             customBody: (domicilio) => (
//                                 <GCheckbox 
//                                     value={false}
//                                     onChange={() => handleChange("medico", domicilio)}
//                                 />
//                             )
//                         },
//                         {
//                             label: "Localidad",
//                             customBody: (domicilio) => domicilio.localidad ? domicilio.localidad : "No informado"
//                         },
//                         {
//                             label: "Provincia",
//                             customBody: (domicilio) => domicilio.provincia ? domicilio.provincia : "No informado"
//                         },
//                         {
//                             label: "Teléfono",
//                             customBody: (domicilio) => domicilio.telefono ? domicilio.telefono : "No informado"
//                         }
//                     ]
//                 } : {}),

//             ].map(({columns, title, data}, index) => (
//                 <Fragment key={index}>
//                     {data && (
//                         <Grid container>
//                             <Grid item xs={12} style={{marginTop: "0.5em"}}>
//                                 <Typography variant="h6">{title}</Typography>
//                             </Grid>
//                             <Grid item xs={12}>
//                                 <GenericTable
//                                     ref={componentRef}
//                                     data={data}
//                                     withoutPagination
//                                     align="center"
//                                     columns={columns}
//                                 />
//                             </Grid>
//                         </Grid>
//                     )}
//                 </Fragment>
//             ))}
//         </Fragment>
//     )
// }

const ModalFecha = ({ handleSave }) => {
    const dispatch = useDispatch()
    const [values, setValues] = useState({
        fecha: moment(),
        hora: "",
        minutos: ""
    });
    const formatHorario = (hora, minutos) => {
        return `${("0" + hora).slice(-2)}:${("0" + minutos).slice(-2)}`;
    }
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
                <ValidatedDate
                    style={{ padding: "0 0.5em" }}
                    value={values.fecha}
                    label="Fecha"
                    onChange={(date) => setValues({ ...values, fecha: date })}
                    fullWidth
                    validations={[required]}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextField
                    type='number'
                    fullWidth
                    label="Hora (00 a 23)"
                    name="hora"
                    value={values.hora}
                    onChange={(e) => { if (e.target.value.length < 3) setValues({ ...values, hora: e.target.value }) }}
                />

            </Grid>
            <Grid item xs={12} md={3}>
                <TextField
                    type='number'
                    fullWidth
                    label="Minutos (00 a 59)"
                    name="minutos"
                    value={values.minutos}
                    onChange={(e) => { if (e.target.value.length < 3) setValues({ ...values, minutos: e.target.value }) }}
                />
            </Grid>
            <Grid item xs={12} style={{ textAlign: "end", marginTop: "1em" }}>
                <ButtonGeneric
                    type="button"
                    text="Guardar"
                    size="small"
                    onClick={() => {
                        (parseInt(values.hora) <= 23 && parseInt(values.minutos) <= 59) ?
                            handleSave({ fecha: moment(values.fecha).format("MM/DD/YYYY"), hora: formatHorario(values.hora, values.minutos) }) :
                            dispatch(startAlerta("Formato de Hora Inválido. Revisar!", "error", "Error"))
                    }}
                />
            </Grid>
        </Grid>
    )
}